/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const DELETEMENTORREQURIEMENT= createAsyncThunk(
  "deleteMentorRequirement/deleteMentorRequirement",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteMentorRequirementSlice = createSlice({
  name: "deleteMentorRequirementSlice",
  initialState: {
    deleteMentorRequirement: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteMentorRequirement: (state) => {
        state.deleteMentorRequirement.loading = false
        state.deleteMentorRequirement.error = false
        state.deleteMentorRequirement.data = []
        state.deleteMentorRequirement.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEMENTORREQURIEMENT.fulfilled, (state, action) => {
      state.deleteMentorRequirement = {
        ...state.deleteMentorRequirement,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEMENTORREQURIEMENT.pending, (state, action) => {
      state.deleteMentorRequirement = {
        ...state.deleteMentorRequirement,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEMENTORREQURIEMENT.rejected, (state, action) => {
      state.deleteMentorRequirement = {
        ...state.deleteMentorRequirement,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteMentorRequirementAction = {
    DELETEMENTORREQURIEMENT,
};

export { deleteMentorRequirementAction };
export default deleteMentorRequirementSlice.reducer;
export const {setInitialStateOfdeleteMentorRequirement} = deleteMentorRequirementSlice.actions